import { useProgressBar } from '@crehana/layouts/spa/hooks/use-progress-bar';
import { useSendFBPixelOnNavigate } from '@crehana/layouts/spa/hooks/use-send-fb-pixel-on-navigate';

import { useLocation } from '../modern-router';

/**
 * Add base functionality to the app
 *
 * - Progress bar
 * - FB Pixel on navigate
 *
 * I have created this component so the re-render of the internal hooks
 * will not affect the parent component
 */
export const AddBaseFunctionality = () => {
  const pathname = useLocation();

  useProgressBar(pathname);
  useSendFBPixelOnNavigate(pathname);

  return null;
};
